import React from 'react';
import Panel from '../../../../components/outline/Panel';
import InfoTable from '../../../../components/table/InfoTable';
import InputForm from '../../../../components/form/InputForm';
import {
  BALANCE_COMMON_MAXIMUM_PRICE,
  BALANCE_COMMON_MINIMUM_PRICE,
  BALANCE_PERIOD_TYPE,
  BALANCE_PERIOD_TYPE_TEXT,
  BALANCE_STATUS_TEXT,
  MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_HOLDER_TEXT,
  MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_NUMBER_TEXT,
  MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_BANK_NAME_TEXT,
  MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_MEMO_TEXT,
  BALANCE_CREATE_MANAGEMENT_TYPE_TEXT,
} from '../../../../constants/service/app/balanceConstants';
import TextAreaForm from '../../../../components/form/TextAreaForm';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';
import { formRequiredRules } from '../../../../lib/formRules';
import BaseForm from '../../../../components/form/BaseForm';
import { setDateFormat } from '../../../../lib/moment';
import { setDash, setPhoneFormat, setNumberWithComma } from '../../../../lib/common';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import SendMessageService from '../../../../containers/app/common/SendMessageService';
import { REX_ACCOUNT_HOLDER } from '../../../../lib/rex';
import './BalanceDetailInfo.scss';

const BalanceDetailInfo = (props) => {
  const { form, setData, balanceInfo } = props;

  return (
    <Panel className="balance-detail-info">
      <div className="panel-body">
        <InfoTable className="left">
          <tbody>
            <tr>
              <td className="label tc">정산번호</td>
              <td className="tc">{balanceInfo.balanceId}</td>
              <td className="label tc">브랜드명</td>
              <td className="tc">
                <OpenBrandDetail text={balanceInfo.brandName} storeId={balanceInfo.storeId} />
              </td>
            </tr>
            <tr>
              <td className="label tc">정산 기준일</td>
              <td className="tc">
                {balanceInfo.balancePeriodType === BALANCE_PERIOD_TYPE.DAILY
                  ? setDateFormat(balanceInfo.baseDate, DATE_FORMAT.YMD_DASH_FORMAT)
                  : '-'}
              </td>
              <td className="label tc">정산 예정일</td>
              <td className="tc">{setDateFormat(balanceInfo.dueDate, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
            </tr>
            <tr>
              <td className="label tc">정산상태</td>
              <td className="tc">{BALANCE_STATUS_TEXT[balanceInfo.status]}</td>
              <td className="label tc">판매자 전화번호</td>
              <td className="tc">
                <SendMessageService
                  text={setPhoneFormat(balanceInfo.sellerPhone)}
                  memberType={AMONDZ_MEMBER_TYPE.SELLER}
                  targetId={balanceInfo.storeId}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">정산 완료일</td>
              <td className="tc">{setDateFormat(balanceInfo.completeDate, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
              <td className="label tc">총 제품 판매 수</td>
              <td className="tc">{setNumberWithComma(balanceInfo.totalItemQuantity, '개')}</td>
            </tr>
            <tr>
              <td className="label tc">정산 주기 타입</td>
              <td className="tc">{setDash(BALANCE_PERIOD_TYPE_TEXT[balanceInfo.balancePeriodType])}</td>
              <td className="label tc">정산 생성 관리 주체</td>
              <td className="tc">{setDash(BALANCE_CREATE_MANAGEMENT_TYPE_TEXT[balanceInfo.createManager])}</td>
            </tr>
            <tr>
              <td className="label tc">월간정산일</td>
              <td className="tc">{setDash(balanceInfo.balanceDay)}</td>
              <td className="label tc">월간정산주기</td>
              <td className="tc">{setDash(balanceInfo.balancePeriod)}</td>
            </tr>
            <tr>
              <td className="label tc">총 결제금액</td>
              <td className="tc">{setNumberWithComma(balanceInfo.totalPrice, '원')}</td>
              <td className="label tc">수수료합</td>
              <td className="tc">{setNumberWithComma(balanceInfo.totalSumFee, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">쿠폰 사용 금액</td>
              <td className="tc">{setNumberWithComma(balanceInfo.totalUsedCouponPrice, '원')}</td>
              <td className="label tc">포인트 사용액</td>
              <td className="tc">{setNumberWithComma(balanceInfo.totalUsedPoint, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">PG 수수료</td>
              <td className="tc fee">{setNumberWithComma(balanceInfo.totalPgFee, '원')}</td>
              <td className="label tc">PG 수수료 VAT</td>
              <td className="tc vat">{setNumberWithComma(balanceInfo.totalPgFeeVat, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">마케팅 수수료</td>
              <td className="tc fee">{setNumberWithComma(balanceInfo.totalMarketingFee, '원')}</td>
              <td className="label tc">마케팅 수수료 VAT</td>
              <td className="tc vat">{setNumberWithComma(balanceInfo.totalMarketingFeeVat, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">아몬즈 수수료</td>
              <td className="tc fee">{setNumberWithComma(balanceInfo.totalAmondzFee, '원')}</td>
              <td className="label tc">아몬즈 수수료 VAT</td>
              <td className="tc vat">{setNumberWithComma(balanceInfo.totalAmondzFeeVat, '원')}</td>
            </tr>
            <tr>
              <td className="label tc">풀필먼트 수수료</td>
              <td className="tc fee">{setNumberWithComma(balanceInfo.totalFulfillmentFee, '원')}</td>
              <td className="label tc">풀필먼트 수수료 VAT</td>
              <td className="tc vat">{setNumberWithComma(balanceInfo.totalFulfillmentFeeVat, '원')}</td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="right">
          {/*은행명*/}
          <InputForm
            label="은행명"
            form={form}
            rules={[formRequiredRules(true, '은행명을 입력해주세요.')]}
            initialValue={balanceInfo.bankName}
            onChange={(value) =>
              setData({
                path: ['balanceDetail', 'balanceInfo', 'bankName'],
                value,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_BANK_NAME_TEXT}
            name="bankName"
          />

          {/*예금주*/}
          <InputForm
            label="예금주"
            form={form}
            rules={[
              formRequiredRules(true, '예금주를 입력해주세요.'),
              { pattern: REX_ACCOUNT_HOLDER, message: '예금주명은 한글, 영문, (),.! 만 입력 가능합니다.' },
            ]}
            initialValue={balanceInfo.accountHolder}
            onChange={(value) =>
              setData({
                path: ['balanceDetail', 'balanceInfo', 'accountHolder'],
                value,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_HOLDER_TEXT}
            name="accountHolder"
          />

          {/*계좌번호*/}
          <InputForm
            label="계좌번호"
            form={form}
            rules={[formRequiredRules(true, '계좌번호를 입력해주세요.')]}
            initialValue={balanceInfo.accountNumber}
            onChange={(value) =>
              setData({
                path: ['balanceDetail', 'balanceInfo', 'accountNumber'],
                value,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_NUMBER_TEXT}
            name="accountNumber"
          />

          {/*정산 예정 금액*/}
          <BaseForm label="정산 예정 금액" content={setNumberWithComma(balanceInfo.finalBalance, '원')} />

          {/* 정산 집행 금액 */}
          <InputForm
            label="정산 집행 금액"
            type="number"
            form={form}
            rules={[formRequiredRules(true, '최소 집행 금액을 입력해주세요.', false)]}
            style={{ width: 120 }}
            min={BALANCE_COMMON_MINIMUM_PRICE}
            max={BALANCE_COMMON_MAXIMUM_PRICE}
            initialValue={balanceInfo.paidBalance}
            onChange={(value) =>
              setData({
                path: ['balanceDetail', 'balanceInfo', 'paidBalance'],
                value,
              })
            }
            addonAfter="원"
            name="paidBalance"
          />

          {/* 지급 보류 금액 */}
          <InputForm
            label="지급 보류 금액"
            type="number"
            form={form}
            rules={[formRequiredRules(true, '지급 보류 금액을 입력해주세요.', false)]}
            style={{ width: 120 }}
            min={BALANCE_COMMON_MINIMUM_PRICE}
            max={BALANCE_COMMON_MAXIMUM_PRICE}
            initialValue={balanceInfo.holdBalance}
            onChange={(value) =>
              setData({
                path: ['balanceDetail', 'balanceInfo', 'holdBalance'],
                value,
              })
            }
            addonAfter="원"
            name="holdBalance"
          />

          {/* 정산 추가 금액 */}
          <InputForm
            label="정산 추가 금액"
            type="number"
            form={form}
            layout="vertical"
            style={{ width: 120 }}
            min={BALANCE_COMMON_MINIMUM_PRICE}
            max={BALANCE_COMMON_MAXIMUM_PRICE}
            initialValue={balanceInfo.extraBalance}
            onChange={(value) =>
              setData({
                path: ['balanceDetail', 'balanceInfo', 'extraBalance'],
                value,
              })
            }
            addonAfter="원"
            name="extraBalance"
          />

          {/*메모*/}
          <TextAreaForm
            form={form}
            label="메모"
            rules={[formRequiredRules(true, '메모를 입력해주세요.')]}
            initialValue={balanceInfo.memo}
            onChange={(value) =>
              setData({
                path: ['balanceDetail', 'balanceInfo', 'memo'],
                value,
              })
            }
            name="memo"
            maxLength={MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_MEMO_TEXT}
            rows={5}
          />
        </div>
      </div>
    </Panel>
  );
};

export default BalanceDetailInfo;
